import { createContext, useContext } from 'react';

export type TrackingData = Record<string, unknown>;

// Optional, subtree-scoped attribution for shared commerce controls, including portals.
export const TrackingContext = createContext<TrackingData>({});
export const ProductTrackingContext = createContext<
  ((product: unknown) => TrackingData) | undefined
>(undefined);

export const useProductTrackingContext = () => useContext(ProductTrackingContext);
export const useTrackingContext = () => useContext(TrackingContext);
